<template>
	<main class="vx-row">
		<div class="vx-col w-full md:w-5/6 lg:w-1/2">

			<div class="block mb-6">
				<a href="#" @click.prevent="verifyData" class="flex items-center">
					<img src="/assets/images/profile/account/verify.png" class="w-16 md:w-12 mr-4" alt="" />
					<strong class="text-dark">Kelengkapan Data & Berkas</strong>
				</a>
			</div>
		</div>
	</main>
</template>
<script>
	import {mapState} from 'vuex'

	export default {
		methods: {
			verifyData() {
				this.$emit('verifyData')
			}
		},
		data: () => ({
			data: {}
		}),
		computed: {
			...mapState('auth', ['profile'])
		},
		created() {
			Object.assign(this.data, this.profile)
		}
	}
</script>